import { defineComponent, reactive, onMounted } from 'vue';
// import LoginAll from "@/components/LoginAll.vue";
// import LoginAbout from "@/components/AboutLogin.vue";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import router from '@/router';
import { QCInfo } from '@/utils/qqInfo.js';
import { IS_DEV } from '@/config/env';
// defineComponent 可以有智能提示
export default defineComponent({
  mounted() {
    console.log('QCInfo:', QCInfo);
    window.addEventListener('message', this.handleMessage, false);
  },
  deactivated() {
    console.log('deactivated----');
    //销毁监听事件
    window.removeEventListener('message', this.handleMessage, false);
  },
  setup() {
    let store = useStore();
    const $router = useRouter();
    onMounted(() => {
      // console.log('_sdi', window._sdi);
      // 水滴 登录页曝光
      window._sdi.stat({
        ptype: '9',
        stype: '1'
      });
    });
    const iframeSrc = encodeURI(IS_DEV ? QCInfo.beta.login_url : QCInfo.prod.login_url);
    const handleMessage = e => {
      let data = e.data;
      if (data && data.type && data.type == 'sendCode') {
        let code = data.data;
        getUserInfo(code);
      }
    };
    const getUserInfo = data => {
      if (data.confirmed == 3) {
        router.push({
          path: '/chooseidentity'
        });
      } else {
        router.push({
          path: '/softwarelibrary'
        });
      }
    };
    let data = reactive({
      isAgree: false
    });
    const getCssVarName = type => {
      return `--el-box-shadow${type ? '-' : ''}${type}`;
    };
    const agree = () => {
      data.isAgree = true;
    };
    const linkClick = async value => {
      localStorage.setItem('agreementItem', value);
      window.open('/software-platform/useragreement');
    };
    const goContactus = () => {
      window.open('/software-platform/contactus');
    };
    return {
      getCssVarName,
      data,
      agree,
      linkClick,
      iframeSrc,
      handleMessage,
      goContactus,
      router
    };
  }
  // components: { LoginAbout }
  // components: { LoginAll, LoginAbout }
});